import * as PIXI from 'pixi.js';
import { EventEmitter } from 'events';
import Balance from 'dt-common/constants/Balance';
import XPBar from '~/components/common/XPBar';

const { getXPForLevel } = Balance;

const AnimatedLevelBar = function({ roster_hero, hero_before_battle }) {
  PIXI.Container.call(this);

  this.eventEmitter = new EventEmitter();

  this.xpDummy = hero_before_battle.xp; // 0
  this.levelDummy = hero_before_battle.level;
  this.xpDummyCeiling = getXPForLevel(this.levelDummy + 1)  - getXPForLevel(this.levelDummy);

  TweenMax.delayedCall(1.5, TweenMax.to,
    [this, 2.5, {
      xpDummy: roster_hero.xp,
      onUpdate: ()=> {
        var levelProgress = Math.round(this.xpDummy - getXPForLevel(this.levelDummy));
        this.xpBar.update(levelProgress, this.xpDummyCeiling);
        if (levelProgress >= this.xpDummyCeiling) {
          ++this.levelDummy;
          this.xpDummyCeiling = getXPForLevel(this.levelDummy + 1) - getXPForLevel(this.levelDummy);

          this.eventEmitter.emit('ALB_SHOW_LEVEL_UP', {
            heroHandle: roster_hero.handle,
            levelShown: this.levelDummy,
          });
        }
      },
    },
  ]);

  var xpBar = this.xpBar = new XPBar({ roster_hero });
  xpBar.update(Math.round(this.xpDummy - getXPForLevel(this.levelDummy)), this.xpDummyCeiling || 0);
  this.addChild(xpBar);
};
AnimatedLevelBar.prototype = Object.create(PIXI.Container.prototype);
AnimatedLevelBar.prototype.constructor = AnimatedLevelBar;
export default AnimatedLevelBar;
